<app-base-modal
  [title]="'История изменений'"
>
  @if (sortedHistoryData.length) {
    <div class="container">
      @for (history of sortedHistoryData; track $index) {
        <div class="history-content">
          <div class="history-top">
            <span class="history-time">
              {{ russianTime(history.time) }}
            </span>
            @if (history.author) {
              <span class="history-author">
                {{ history.author }}
              </span>
            }
          </div>
          <span class="history-sender">
            {{ history.title }}
          </span>
          <p class="history-text">
            <span>
              {{ history.description }}
            </span>
          </p>
        </div>
      }

    </div>
    <div class="buttons-container">
      <button
        mat-button
        color="primary"
        tabindex="-1"
        (click)="closeDialog('cancel')"
      >
        Закрыть
      </button>
    </div>
  }
</app-base-modal>

